module.exports = __webpack_public_path__ + "img/title.121656dd.png";